import $ from 'jquery'
import * as contactDetail from './contact-detail-settings.js'
import * as mlaContactDetail from './mla-contact-detail-settings.js'
import { initUpload } from './form-upload.js'
import RequiredFields from './contact-required-fields.js'
import Query from './parse-query.js'
import {
  addAdditionalRulesValidators,
  buildAdditionalValidationRulesAndMessages
} from './eloqua-form/additional-rules.js'

const loadDependencies = async () => {
  await import(/* webpackChunkName: "blueimp-file-upload" */ 'blueimp-file-upload')
  await import(/* webpackChunkName: "jq-validation-additional-methods" */ 'jquery-validation/dist/additional-methods.js')
}

// validation rules for each form-field
const $contactDetailForm = $('#contact-detail-form'),
  $requestTopic = $contactDetailForm.find('#RequestTopic'),
  $requestInterest = $contactDetailForm.find('#RequestInterest')

let settings

//if MLA take MLA setting if not take default contact detail
if ($contactDetailForm.attr('data-campaign-name') && $contactDetailForm.attr('data-campaign-name') == 'mla') {
  settings = mlaContactDetail
} else {
  settings = contactDetail
}

const countryCode = window.backend_properties.locale

const rulesObjectBlueprint = {
  RequestInterest: {
    valueNotEquals: 'default'
  },
  RequestTopic: {},
  Salutation: {
    valueNotEquals: 'default'
  },
  FirstName: {
    maxlength: 100
  },
  LastName: {
    maxlength: 100
  },
  Company: {
    maxlength: 100
  },
  Address: {
    maxlength: 100
  },
  City: {
    maxlength: 100
  },
  Country: {
    maxlength: 100
  },
  Location: {
    valueNotEquals: 'default'
  },
  CustomerNumber: {
    maxlength: 100
  },
  AccountNumber: {
    maxlength: 100
  },
  ContractNumber: {
    maxlength: 100
  },
  Email: {
    maxlength: 100
  },
  Environment: {
    maxlength: 100
  },
  Phone: {
    required: {
      depends: function () {
        return phoneDepends()
      }
    },
    maxlength: 50
  },
  CompanyRegistrationNo: {
    maxlength: 100,
  },
  CallbackRequest: {
    valueNotEquals: 'default'
  },
  CustomerType: {
    valueNotEquals: 'default'
  },
  RequestMessage: {
    maxlength: 500
  },
  OptinRequest: {
    valueNotEquals: 'default'
  },
  DataProtectionAgreement: {
    valueNotEquals: 'default'
  },
  State: {
    valueNotEquals: 'default'
  },
  // for styling
  placeholder: {}
}

let errorMessages = window.formErrors ? {
  FirstName: {
    required: window.formErrors.default,
    maxlength: window.formErrors.inputMaxLength100,
  },
  LastName: {
    required: window.formErrors.default,
    maxlength: window.formErrors.inputMaxLength100,
  },
  Country: {
    required: window.formErrors.default,
    maxlength: window.formErrors.inputMaxLength100
  },
  Address: {
    required: window.formErrors.default,
    maxlength: window.formErrors.inputMaxLength100
  },
  Company: {
    required: window.formErrors.default,
    maxlength: window.formErrors.inputMaxLength100
  },
  CustomerNumber: {
    required: window.formErrors.default,
    maxlength: window.formErrors.inputMaxLength100
  },
  AccountNumber: {
    required: window.formErrors.default,
    maxlength: window.formErrors.inputMaxLength100
  },
  ContractNumber: {
    required: window.formErrors.default,
    maxlength: window.formErrors.inputMaxLength100
  },
  Email: {
    required: window.formErrors.default,
    email: window.formErrors.email,
    maxlength: window.formErrors.inputMaxLength100
  },
  PostalCode: {
    required: window.formErrors.default,
  },
  PostalBox: {
    required: window.formErrors.default,
  },
  VATNumber: {
    required: window.formErrors.default,
  },
  TaxID: {
    required: window.formErrors.default,
  },
  AgbAccepted: {
    required: window.formErrors.agb
  },
  CompanyRegistrationNo: {
    required: window.formErrors.default,
    maxlength: window.formErrors.inputMaxLength100,
  },
  RequestMessage: {
    required: window.formErrors.default,
    maxlength: window.formErrors.inputMaxLength500
  },
  Phone: {
    required: window.formErrors.default,
    maxlength: window.formErrors.inputMaxLength50,
  },
  State: {
    required: window.formErrors.default,
  },
  DataProtectionAgreement: window.formErrors.default,
  FiscalCode: window.formErrors.inputNumber,
  OptinRequest: {
    required: window.formErrors.default,
  }
} : {}

const dowpdownValidationFields = ['RequestInterest', 'Salutation', 'Location', 'CustomerType', 'State']

const clocks = settings.countryClocks(countryCode)

// validation rules
const defaultValidation = settings.countryRequiredFields(countryCode, 'default')
const consulting = settings.countryRequiredFields(countryCode, 'consulting')
const offersGeneral = settings.countryRequiredFields(countryCode, 'offersGeneral')
const offersInvestment = settings.countryRequiredFields(countryCode, 'offersInvestment')
const other = settings.countryRequiredFields(countryCode, 'other')
const customer_serviceGeneral = settings.countryRequiredFields(countryCode, 'customer_serviceGeneral')
const customer_serviceBank = settings.countryRequiredFields(countryCode, 'customer_serviceBank')
const investor_relations = settings.countryRequiredFields(countryCode, 'investor_relations')
const career = settings.countryRequiredFields(countryCode, 'career')
const press = settings.countryRequiredFields(countryCode, 'press')
const cooperation = settings.countryRequiredFields(countryCode, 'cooperation')

// final rules
let requiredFields = defaultValidation

// jquery validate object
let contactDetailForm

async function init () {
  if ($contactDetailForm.length) {
    await loadDependencies()
    handleFormLayout()
    setDynamicRulesAndMessages()
    initValidation()
    handleExternalSource()
    if ($('.upload-js')) {
      initUpload(window.contactDetailPages.apiFileUpload, $('.upload-js'), window.contactDetailPages.errorPage)
    }
    handleContactLocalStorage()
    handleShowMultipleNumbers()

    //set default required fields
    RequiredFields.setRequiredFieldsByRequestInterest(requiredFields)
  }
  if (window.location.search) {
    fillFormFields()
  }

  if (localStorage.leasingtest) {
    let campaignInfo = $('input[name="CampaignInfo"]')

    if (campaignInfo) {
      campaignInfo.val(JSON.parse(localStorage.leasingtest))
    }
  }
  handleEnterPress()
}

function handleEnterPress () {
  Array.from($contactDetailForm.find(':input'))
    .filter(tag => tag.type === 'text' || tag.type === 'email' || tag.type === 'number')
    .forEach(input => input.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        e.stopPropagation()
        e.preventDefault()
        $contactDetailForm.trigger('submit')
      }
    }))
}

function handleExternalSource () {
  if (sessionStorage.source) {
    $('#CampaignParameter').val(sessionStorage.source)
  }
}

function fillFormFields () {
  let queryString = (window.location.search).split('?')[1]

  if (queryString.indexOf('contactTeaserData') !== -1) {
    if (queryString.split('contactTeaserData=')[1]) {
      let decodedQueryParam = atob(queryString.split('contactTeaserData=')[1])
      let queryParams = Query.parseQuery(decodedQueryParam)
      let keys = Object.keys(queryParams)

      keys.forEach(function (key) {
        if (queryParams[key] != '') {
          $contactDetailForm.find('[name="' + key + '"]')
            .val(queryParams[key])
            .change()
        }
      })
    }
  }
}

function initValidation () {
  $.validator.setDefaults({
    debug: false,
    success: 'valid',
    messages: errorMessages
  })

  $.validator.addMethod('valueNotEquals', function (value, element, arg) {
    return arg !== value
  }, window.formErrors.dropdown)

  // Default PostalBox validator. Will be overwritten below if a validationRule for the field exists.
  $.validator.addMethod('PostalBox', function (value, element, param) {
    return true
  })

  addAdditionalRulesValidators()

  setValidation()
}

function handleFormLayout () {
  $requestInterest.on('change', function () {
    let selectedValue = $(this).val()
    RequiredFields.resetRequiredFieldsByRequestInterest()

    // set data-attr for hide and show fields
    $contactDetailForm.attr('data-form-interest', selectedValue)
    $contactDetailForm.attr('data-form-topic', '')

    let topicListItems = []

    $('#requestTopic-col').find('.formRow--dropdown-list-item').each((index, item) => {
      if ($(item).css('display') === 'block') {
        topicListItems.push(item)
      }
    })

    if (topicListItems.length === 1) {
      //pre-fill topic when only one option available
      let topic = $(topicListItems).data('dropdown-value')
      $requestTopic.val(topic)
      $requestTopic.trigger('update')
      $requestTopic.trigger('change')
    } else {
      // reset requestTopic
      $requestTopic.val('default')
      $requestTopic.siblings('.formRow--dropdown-field').html('&nbsp;')
      $requestTopic.parent('.js-dropdownWrapper').removeClass('active')
    }

    // Clear input
    $('[data-customer-service-item]').find('input').val('')
    if ($('.contact-detail-form-interest-row').hasClass('d-none')) {
      $('html, body').animate({ scrollTop: $('#contact-detail-form').offset().top - 100 }, 1000)
    } else if (!$('#requestTopic-col').is(':visible')) {
      $('html, body').animate({ scrollTop: $('#form-start-marker-js').offset().top - 100 }, 1000)
    }
    updateValidation()
  })
  $requestTopic.on('change', function () {
    let selectedValue = $(this).val()
    RequiredFields.resetRequiredFieldsByRequestInterest()
    // set data-attr for hide and show fields
    $contactDetailForm.attr('data-form-topic', $(this).val())
    // scroll to FAQ if visible, otherwise scroll to form
    if ($('.faq-banking-row').is(':visible')) {
      $('html, body').animate({ scrollTop: $('.faq-banking-row').offset().top - 100 }, 1000)
    } else if ($('.contact-detail-form-interest-row').hasClass('d-none')) {
      $('html, body').animate({ scrollTop: $('#contact-detail-form').offset().top - 100 }, 1000)
    } else {
      $('html, body').animate({ scrollTop: $('#form-start-marker-js').offset().top - 100 }, 1000)
    }
    updateValidation()
  })
  // validate dropdowns
  $contactDetailForm.find('select').on('change', function (ev, element) {
    if (element != undefined) {
      contactDetailForm.element(element)
    }
  })
  $('#CallbackRequest').on('change', function () {
    const $phoneError = $('#Phone-error'),
      $phoneTimeWrapper = $('#phone-time-wrapper-js')

    if ($(this).is(':checked')) {
      $phoneError.addClass('valid')
      $phoneTimeWrapper.collapse('show')
    } else {
      $phoneError.removeClass('valid')
      $phoneTimeWrapper.collapse('hide')
      $phoneTimeWrapper.find('input[type=checkbox]').prop('checked', false)
    }
    $('#Phone').valid()

    $.each(clocks, function (key, value) {
      $(`#${value}`).valid()
    })

  })
}

function getRequiredFields () {
  let interest = $contactDetailForm.attr('data-form-interest'),
    topic = $contactDetailForm.attr('data-form-topic')

  if (interest == 'Consulting') {
    if (topic == 'Banking_Services') {
      let _consulting = $.merge([], consulting)
      _consulting.splice(_consulting.indexOf('Company'), 1)
      requiredFields = _consulting
    } else {
      requiredFields = consulting
    }
  } else if (interest == 'Investor_Relations') {
    requiredFields = investor_relations
  } else if (interest == 'Press') {
    requiredFields = press
  } else if (interest == 'Career') {
    requiredFields = career
  } else if (interest == 'Other') {
    requiredFields = other
  } else if (interest == 'Offers' && topic == 'Investment') {
    requiredFields = offersInvestment
  } else if (interest == 'Offers') {
    requiredFields = offersGeneral
  } else if (interest == 'Customer_Service' && topic == 'Banking') {
    requiredFields = customer_serviceBank
  } else if (interest == 'Customer_Service') {
    requiredFields = customer_serviceGeneral
  } else if (interest == 'Cooperation') {
    requiredFields = cooperation
  } else {
    requiredFields = defaultValidation
  }

  return requiredFields
}

function updateValidation () {
  getRequiredFields()

  resetValidation()
  destroyValidation()
  setValidation()
  RequiredFields.setRequiredFieldsByRequestInterest(getRequiredFields())
}

function resetValidation () {
  $('[data-form-input-name], [data-customer-service-item]').not(':visible').each(function () {
    $(this).find('.js-inputWrapper').removeClass('active')
    $(this).find('input').val('')
  })
  $('.investor-relations-row').not(':visible').each(function () {
    $(this).find('.js-dropdownWrapper').removeClass('active')
    $(this).find('select').val('default')
    $(this).find('.formRow--dropdown-field').html('&nbsp;')
  })
  contactDetailForm.reset()
  // reset CallbackRequest and Callbacktimes
  $('.phone-time').prop('checked', false)
  $('#CallbackRequest').prop('checked', false)
  $('#phone-time-wrapper-js').collapse('hide')

  $('label.error').remove()
  $('[data-form-input-name], [data-customer-service-item]').find('input').prop('disabled', false)
}

function destroyValidation () {
  contactDetailForm.destroy()
}

function setDynamicRulesAndMessages () {
  const availableClocks = $('input[name^=\'clock\'].phone-time')

  availableClocks.each(function () {
    rulesObjectBlueprint[$(this).attr('name')] = {
      require_from_group: function () {
        return clockRequireFromGroup()
      }
    }
    errorMessages[$(this).attr('name')] = window.formErrors.checkboxMinOne
  })
}

let sent = false

function setValidation () {
  contactDetailForm = $contactDetailForm.validate({
    ignore: [],
    focusInvalid: false,
    onkeyup: function (element, event) {
      if ($(element).attr('name') != 'Email') {
        $(element).valid()
      }
    },
    onfocusout: function (element) {
      $(element).valid()
    },
    onclick: function (element) {
      if ($(element).hasClass('formRow--checkbox')) {
        $(element).valid()
      }
    },
    rules: generateRulesObject(),
    errorPlacement: function (error, $element) {
      let name = $element.attr('name')

      if (clocks.indexOf(name) !== -1) {
        if (!$('#phone-time-error').find('.error').length) {
          error.appendTo($('#phone-time-error'))
        }
      } else {
        error.insertAfter($element)
      }
    },
    invalidHandler: function (form, validator) {
      if (!validator.numberOfInvalids()) {
        return
      }

      // 50px for better look
      let headerHeight = $('header').height() + 50

      $('html, body').animate({
        scrollTop: ($(validator.errorList[0].element).offset().top - headerHeight)
      }, 1000)
    },
    submitHandler: function (form) {
      if (!sent) {
        sent = true
        let now = new Date(),
          $submitButton = $contactDetailForm.find('[type=submit]')

        $contactDetailForm.find('[name=RequestDate]').val(now.toISOString())
        $contactDetailForm.find('[name=RequestDateGMT]').val(now.toUTCString())
        $submitButton.prop('disabled', true).css('cursor', 'wait')
        document.body.style.cursor = 'wait'

        //set data-security-label
        if ($('[data-security-label]:visible').data('security-label') && $('[name=\'OwningEntity\']')) {
          let securityLabel = $('[data-security-label]:visible').data('security-label'),
            owningEntity = $('[name=\'OwningEntity\']')

          securityLabel = securityLabel.replace(';', '~')
          owningEntity.val(securityLabel)
        }

        $('[data-form-input-name], [data-customer-service-item], #optin-default, #optin-locazione, #optin-factoring').not(':visible').find('input').prop('disabled', true)

        $.ajax({
          url: form.action,
          method: 'POST',
          data: $(form).serialize(),
          success: function (response, statusText, xhr) {
            //console.log("xhr status:", xhr.status);
            //console.log("response is", response);
            if (xhr.status == 200) {
              let interest = $contactDetailForm.attr('data-form-interest'),
                topic = $contactDetailForm.attr('data-form-topic'),
                successPage = contactDetailPages.successPage

              successPage += '?interest=' + interest

              if (topic != '') {
                successPage += '&topic=' + topic
              }

              if (sessionStorage.source) {
                sessionStorage.removeItem('source')
              }

              if ($contactDetailForm.attr('data-campaign-name') != undefined) {
                if ($contactDetailForm.attr('data-campaign-name') == 'mla' && $('#PageSource').val() != '') {
                  let pageSource = $('#PageSource').val()
                  let start,
                    end,
                    product

                  // if URL end with trailing-slash remove it
                  if (pageSource.match(/\/$/)) {
                    pageSource = pageSource.slice(0, -1)
                  }

                  start = pageSource.lastIndexOf('/') + 1
                  end = pageSource.length
                  product = pageSource.substring(start, end)

                  successPage += '&product=' + product
                }
              }
              if (localStorage.leasingtest) {
                localStorage.removeItem('leasingtest')
              }

              const requestInterest = $contactDetailForm.find('#RequestInterest').val() || ''
              const requestTopic = $contactDetailForm.find('#RequestTopic').val() || ''

              sendTrackingEventToTrackingManager(requestInterest + ' ' + requestTopic)
              location.href = successPage.toLocaleLowerCase()
            } else if (xhr.status == 400 || xhr.status == 403) {
              window.location.href = contactDetailPages.errorPage
            }
          },
          error: function (jqXHR, textStatus, errorThrown) {
            window.location.href = contactDetailPages.errorPage
          },
        })
      }
    }
  })
}

function sendTrackingEventToTrackingManager (eventText) {
  const event = new CustomEvent('eloqua-form-sent', { detail: eventText })
  document.dispatchEvent(event)
}

function handleContactLocalStorage () {
  if (localStorage.getItem('contact.pageSource')) {
    let pageSource = localStorage.getItem('contact.pageSource')
    $('#PageSource').val(pageSource)
    localStorage.removeItem('contact.pageSource')
  }
  if (localStorage.getItem('contact.interest')) {
    let interest = localStorage.getItem('contact.interest')

    if ($contactDetailForm.find('[data-dropdown-value=' + interest + ']').css('display') == 'block') {
      $requestInterest.val(interest)
      localStorage.removeItem('contact.interest')
      $requestInterest.trigger('update')
      $requestInterest.trigger('change').promise().done(function () {
        if (localStorage.getItem('contact.topic')) {
          let topic = localStorage.getItem('contact.topic')

          if ($contactDetailForm.find('[data-dropdown-value=' + topic + ']').css('display') == 'block') {
            $requestTopic.val(topic)
            localStorage.removeItem('contact.topic')
            $requestTopic.trigger('update')
            $requestTopic.trigger('change')
          }
        }
      })
    }
  }
}

function generateRulesObject () {
  let rulesObject = jQuery.extend(true, {}, rulesObjectBlueprint)

  buildAdditionalValidationRulesAndMessages(rulesObject, errorMessages)

  // Removes validation from dropdown if not selected in settings
  $.each(dowpdownValidationFields, (key, val) => {
    if (requiredFields.indexOf(val) == -1) {
      delete rulesObject[val]
    }
  })

  $.each(requiredFields, (key, val) => {
    if (!rulesObject[val]['required'] && !rulesObject[val]['require_from_group']) {
      rulesObject[val]['required'] = true
      if (val === 'RequestTopic') {
        rulesObject[val]['valueNotEquals'] = 'default'
      }
    }
  })

  return rulesObject
}

function phoneDepends () {
  if ($('[name=CallbackRequest]').is(':checked')) {
    return true
  } else if ($.inArray('Phone', settings.countryPermanentRequiredFields(countryCode)) != -1) {
    return true
  } else {
    return false
  }
}

function clockRequireFromGroup () {
  if ($('[name=CallbackRequest]').is(':checked')) {
    return [1, '.phone-time']
  } else {
    return [0, '.phone-time']
  }
}

function handleShowMultipleNumbers () {
  let showMultipleNumbersButton = $('button[data-action=\'show-multiple-numbers\']')
  if (showMultipleNumbersButton) {
    showMultipleNumbersButton.off('click').on('click', function (e) {
      $('.sticky-container.phone').trigger('click')
    })
  }
}

export default {
  init
}
